export const congregationOptions = [
  {value: 1, label: 'Waterbirds'},
  {value: 2, label: 'Seabirds'},
  {value: 3, label: 'Raptors'},
  {value: 4, label: 'Cranes'},
  {value: 5, label: 'Storks'}
]
